import script from "./pseudo.vue?vue&type=script&setup=true&lang=js"
export * from "./pseudo.vue?vue&type=script&setup=true&lang=js"

import "./pseudo.vue?vue&type=style&index=0&id=f03b988c&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f03b988c"]])

export default __exports__